import { connect } from 'react-redux'
import { RiderChangeLog } from 'src/components/riders/riderdetails/RiderChangeLog'
import { IRiderChangeLogDTO, IStoreState } from 'src/types'
import * as actions from '../../../state/actions/riders'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    riderId: ownProps.riderId,
    riderChangeLog: state.riders.rider.riderChangeLog ? state.riders.rider.riderChangeLog.items : [],
    riderChangeLogCount: state.riders.rider.riderChangeLog ? state.riders.rider.riderChangeLog.count : 0
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderChangeLog: (params: IRiderChangeLogDTO): any => {
      return dispatch(actions.riderChangeLog(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderChangeLog)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/RiderChangeLog.ts